export const CLEAR = '@@ref/CLEAR';
export const UPDATE = '@@ref/UPDATE';

export const SET_PARENT_ID = '@@ref/SET_PARENT_ID';
export const SET_PARENT_ADDRESS = '@@ref/SET_PARENT_ADDRESS';
